export default __webpack_public_path__ + "static/media/intellisolution.5cef673b.png";